import React from 'react';
import { Wrapper } from 'app/components/competitionModule/matches/commonStyles';
import SectionHeading from 'app/components/competitionModule/common/SectionHeading';
import SwipeableCompetitionModuleMatches from 'app/components/competitionModule/matches/SwipeableCompetitionModuleMatches';
import MatchesView from 'app/components/competitionModule/matches/MatchesView';
const MATCHES_PER_VIEW = 8;
export default function CompetitionModuleMatches(_ref) {
  let {
    competitionSlug,
    matches
  } = _ref;
  if (!matches.length) {
    return null;
  }
  if (matches.length > MATCHES_PER_VIEW) {
    return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(SectionHeading, null, "Aktuelle Spiele"), /*#__PURE__*/React.createElement(SwipeableCompetitionModuleMatches, {
      matches: matches,
      competitionSlug: competitionSlug
    }));
  }
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "CompetitionModuleMatches",
    "data-sentry-source-file": "CompetitionModuleMatches.tsx"
  }, /*#__PURE__*/React.createElement(SectionHeading, {
    "data-sentry-element": "SectionHeading",
    "data-sentry-source-file": "CompetitionModuleMatches.tsx"
  }, "Aktuelle Spiele"), /*#__PURE__*/React.createElement(MatchesView, {
    matches: matches,
    "data-sentry-element": "MatchesView",
    "data-sentry-source-file": "CompetitionModuleMatches.tsx"
  }));
}